import script from "./MeetingMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MeetingMenu.vue?vue&type=script&setup=true&lang=ts"

import "./MeetingMenu.vue?vue&type=style&index=0&id=1c2c4394&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c2c4394"]])

export default __exports__